<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-10">
        <basic-information :company="company"/>

        <PortalList :company="company"/>

        <ContactList :company="company"/>
      </div>

      <div class="col-xs-14">
        <OpportunityList :company="company"/>

        <meeting-list :company="company.data"/>

        <ReminderList :company="company.data"/>

        <RetentionTouchpointList :company="company.data"/>

        <ProjectLeadList :company="company.data"/>

        <timeline :company="company"/>

        <div v-if="!loading">
          <Partnership
              v-for="partnership in sortedPartnerships"
              :key="partnership.id"
              :partnership="partnership"
          />
        </div>

        <ad-revenue :company="company"/>

        <order-list :company="company"/>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../../../../../http'
import BasicInformation from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/BasicInformation'
import ContactList from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/ContactList'
import MeetingList from '@/components/Companies/Companies/Panels/MeetingList'
import OrderList from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/OrderList'
import AdRevenue from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/AdRevenue'
import Partnership from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/Partnership'
import Timeline from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/Timeline'
import PortalList from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/PortalList'
import OpportunityList from '../../../../../../components/Companies/Companies/Panels/OpportunityList'
import ReminderList from "./Panels/ReminderList.vue";
import ProjectLeadList from "./Panels/ProjectLeadList.vue";
import RetentionTouchpointList from "./Panels/RetentionTouchpointList.vue";

export default {
  components: {
    ProjectLeadList,
    ReminderList,
    OpportunityList,
    BasicInformation,
    ContactList,
    MeetingList,
    OrderList,
    AdRevenue,
    Partnership,
    Timeline,
    PortalList,
    RetentionTouchpointList
  },

  model: {
    prop: 'company',
    event: 'company-updated'
  },

  props: ['company'],

  data() {
    return {
      partnerships: null,
      loading: true
    }
  },

  computed: {
    sortedPartnerships() {
      let partnerships = this.partnerships.slice(0)

      partnerships.sort((a, b) => {
        if (a.status === 'closed') {
          return 1
        }

        if (b.status === 'closed') {
          return -1
        }

        return 0
      })

      return partnerships
    }
  },

  mounted() {
    http.get('/api/v2/partnerships', {
      'filter[company_id]': this.company.data.id,
      'filter[status]': 'active',
      page_size: 100
    }).then(response => {
      this.partnerships = response.data.data

      this.loading = false
    })
  }
}
</script>